import React from "react"
import sisuLogo from "../../../design/assests/images/sisu_logo.png"

export function SurveyHeader({ client, survey }) {
  return (
    <div className="survey-header-container border-b border-gray-300">
      <div className="flex items-center">
        <img src={sisuLogo} alt="SISU" className="h-12 survey-logo" />
      </div>

      <div className="survey-header-text text-center">
        <h1 className="font-cairo font-bold m-0 survey-title">
          {survey?.surveyName}
        </h1>

        <p className="mt-2 survey-client">{client?.clientName}</p>
      </div>

      <div className="flex justify-content-end align-items-center">
        {client?.logoUrl && (
          <img
            src={client.logoUrl}
            alt={client.clientName}
            className="h-12 survey-client-logo "
          />
        )}
      </div>
    </div>
  )
}
